/**
 * Fix para bug conhecido do Radix UI: ao fechar Dialog/Select/Dropdown enquanto
 * outro overlay (toast, sheet, etc.) está aparecendo, o Radix esquece de
 * remover `pointer-events: none` do <body>, deixando a tela inteira "morta".
 *
 * Sintoma do usuário: "consigo clicar uma vez e depois nada mais funciona,
 * preciso recarregar a página".
 *
 * Esta função observa o body via MutationObserver e, sempre que detecta o
 * style `pointer-events: none` SEM nenhum overlay Radix aberto (data-state=open),
 * limpa o style do body.
 */
export function installRadixPointerEventsFix() {
  if (typeof document === 'undefined') return;

  const hasOpenOverlay = () =>
    !!document.querySelector(
      '[data-radix-popper-content-wrapper], [role="dialog"][data-state="open"], [data-state="open"][role="menu"], [data-state="open"][role="listbox"]'
    );

  const cleanup = () => {
    if (document.body.style.pointerEvents === 'none' && !hasOpenOverlay()) {
      document.body.style.pointerEvents = '';
    }
  };

  // Observa mudanças no atributo style do body
  const observer = new MutationObserver(() => {
    // Aguarda um tick para o Radix terminar suas operações
    setTimeout(cleanup, 0);
  });
  observer.observe(document.body, { attributes: true, attributeFilter: ['style'] });

  // Também limpa periodicamente como fallback (caso o observer perca evento)
  setInterval(cleanup, 1500);

  // E em qualquer interação do usuário (clique/tecla) força a verificação
  const onUserAction = () => setTimeout(cleanup, 50);
  window.addEventListener('pointerup', onUserAction, true);
  window.addEventListener('keyup', onUserAction, true);
}